
import { Component, PropSync, Mixins } from 'vue-property-decorator';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { NotificationData } from '@/features/settings/types';
import { updateNotificationPref } from '@/features/settings/services/notifications.services';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class Notification extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  private step = 1;

  private isNeverShowCheck = false;

  get notificationBanner(): string | null {
    try {
      /* eslint-disable global-require */
      return require(`@img/notifications/${this.name}.svg`);
    } catch (e) {
      return null;
    }
  }

  get hideDoNotShow(): boolean {
    return this.$store.getters.getHideDoNotShow;
  }

  get notificationData(): Array<NotificationData> {
    return this.$store.state.notificationData;
  }

  get name(): string {
    return this.notificationData[this.step - 1].name;
  }

  get extras(): unknown {
    return this.notificationData[this.step - 1].extra;
  }

  get btnText(): string {
    return this.$t(`notifications.${this.name}.btnText`) as string;
  }

  get notificationProps(): { showCount: boolean, showDontShowCheck: boolean } {
    const notification = this.notificationData[this.step - 1];
    return {
      showCount: notification.showCount ?? true,
      showDontShowCheck: notification.showDontShowCheck ?? true,
    };
  }

  private neverShowThisNotification() {
    this.$store.commit('patchNotificationPref', {
      name: this.name,
      value: !this.isNeverShowCheck,
    });
    updateNotificationPref(this.name, !this.isNeverShowCheck);
  }

  private submit() {
    if (this.notificationProps.showDontShowCheck && !this.hideDoNotShow) {
      this.neverShowThisNotification();
    }

    if (this.step === this.notificationData.length) {
      eventBus.$emit(eventNames.NOTIFICATION_SUBMIT, this.name);
      eventBus.$emit(eventNames.NOTIFICATION_AGREE, this.name);
      this.syncedShow = false;
    } else {
      eventBus.$emit(eventNames.NOTIFICATION_AGREE, this.name);
      this.step += 1;
      this.isNeverShowCheck = false;
    }
  }

  private reject(): void {
    this.syncedShow = false;
  }
}
